export const appointmentStatus = {
  scheduled: { label: 'Agendada', color: 'blue' },
  pending: { label: 'Pendiente', color: 'amber' },
  paid: { label: 'Pagado', color: 'green' },
  confirmed: { label: 'Confirmada', color: 'sky' },
  completed: { label: 'Atendida', color: 'green' },
  cancelled: { label: 'Cancelada', color: 'red' },
  no_show: { label: 'No asistio', color: 'slate' }
};

export const orderStatus = {
  draft: { label: 'Borrador', color: 'slate' },
  pending: { label: 'Pendiente de pago', color: 'amber' },
  confirmed: { label: 'Confirmado', color: 'sky' },
  accepted: { label: 'En preparacion', color: 'blue' },
  paid: { label: 'Pagado', color: 'green' },
  ready_for_pickup: { label: 'Listo para entregar', color: 'purple' },
  delivered: { label: 'Entregado', color: 'green' },
  completed: { label: 'Completado', color: 'green' },
  cancelled: { label: 'Cancelado', color: 'red' }
};

export const paymentStatus = {
  paid: { label: 'Pagado', color: 'green' },
  pending: { label: 'Pendiente', color: 'amber' },
  failed: { label: 'Fallido', color: 'red' },
  cancelled: { label: 'Cancelado', color: 'slate' },
  refunded: { label: 'Reembolsado', color: 'purple' }
};

export const activeStatus = {
  1: { label: 'Activo', color: 'green' },
  true: { label: 'Activo', color: 'green' },
  active: { label: 'Activo', color: 'green' },
  0: { label: 'Inactivo', color: 'slate' },
  false: { label: 'Inactivo', color: 'slate' },
  inactive: { label: 'Inactivo', color: 'slate' },
  deceased: { label: 'Fallecida', color: 'red' }
};

export const roleLabels = {
  super_admin: 'Super admin',
  admin: 'Administrador de clinica',
  staff: 'Equipo clinico',
  veterinarian: 'Veterinario',
  receptionist: 'Recepcionista',
  warehouse: 'Bodega/tienda',
  viewer: 'Visualizador',
  customer: 'Cliente'
};

export const getStatusConfig = (map, value, fallback = 'Sin estado') => {
  return map[value] || { label: value || fallback, color: 'slate' };
};
